import styled from "styled-components";
import { colorsPalettes, mixins } from "@similarweb/styles";
import { ChipItemWrapper } from "@similarweb/ui-components";
import ChipItemsContainer from "app/pages/sales-intelligence/sub-modules/advanced-search/components/shared/ChipItemsContainer/ChipItemsContainer";

export const DROPDOWN_BODY_HEIGHT = 48 * 6;

export const StyledDDContainer = styled.div<{ hasMargin: boolean }>`
    margin: ${({ hasMargin }) => (hasMargin ? 4 : 0)}px;
`;

export const StyledChipSeparator = styled.span`
    ${mixins.setFontVariant("body2", colorsPalettes.carbon["200"])};
    margin-left: 12px;
    margin-right: 12px;
    text-transform: uppercase;
`;

export const StyledChipItemsContainer = styled(ChipItemsContainer)`
    padding: 0 4px;

    & ${ChipItemWrapper} {
        margin: 4px 0;
    }
`;

export const StyledSelectionWrapper = styled.div<{ hasBorder: boolean; hasPadding: boolean }>`
    border: 1px solid ${({ hasBorder }) => (hasBorder ? colorsPalettes.carbon["100"] : "transparent")};
    padding: ${({ hasPadding }) => (hasPadding ? 4 : 0)}px;

    &.hidden {
        display: none;
    }
`;
